import { BoxProps, Row } from "@hightouch/htui";
import { FC, PropsWithChildren } from "react";

/** Slim bar at the top of the page card, above `PageCardHeader`. */
export const PageCardTopBar: FC<PropsWithChildren<BoxProps>> = ({
  children,
  ...props
}) => {
  return (
    <Row
      align="center"
      minHeight={10}
      py={3}
      pl={6}
      pr={3}
      bg="white"
      borderTopRadius="2xl"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.divider"
      flexShrink={0}
      {...props}
    >
      {children}
    </Row>
  );
};
